<script>
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';

export default {
  components: {
    TemplatesPicker,
    WhatsAppTemplateReply,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    sendRenderedContent: {
      type: Boolean,
      default: false,
    },
    requestContactInfoOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    modalTitle() {
      return this.selectedWaTemplate
        ? 'Preparar mensagem'
        : 'Modelos de mensagem do WhatsApp';
    },
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? `Você selecionou o modelo "${this.selectedWaTemplate.name}". Revise os dados antes de enviar.`
        : 'Encontre o modelo à esquerda, confira a prévia e continue quando estiver pronto.';
    },
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },
  watch: {
    show(value) {
      document.documentElement.classList.toggle(
        'mayara-whatsapp-template-open',
        value
      );

      if (!value) {
        this.selectedWaTemplate = null;
      }
    },
    requestContactInfoOnly() {
      this.selectedWaTemplate = null;
    },
  },
  beforeUnmount() {
    document.documentElement.classList.remove(
      'mayara-whatsapp-template-open'
    );
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="onClose"
    size="modal-big"
    class="mayara-whatsapp-template-modal"
  >
    <div class="mayara-template-shell">
      <div class="mayara-template-heading">
        <div class="mayara-template-icon">
          <i class="i-ph-whatsapp-logo-fill" />
        </div>

        <div class="min-w-0">
          <h3 class="mayara-template-title">
            {{ modalTitle }}
          </h3>
          <p class="mayara-template-subtitle">
            {{ modalHeaderContent }}
          </p>
        </div>
      </div>

      <div
        class="mayara-template-content"
        :class="{ 'mayara-template-content-reply': selectedWaTemplate }"
      >
        <TemplatesPicker
          v-if="!selectedWaTemplate"
          :inbox-id="inboxId"
          :request-contact-info-only="requestContactInfoOnly"
          @on-select="pickTemplate"
        />

        <div v-else class="mayara-reply-stage">
          <WhatsAppTemplateReply
            :template="selectedWaTemplate"
            :send-rendered-content="sendRenderedContent"
            @reset-template="onResetTemplate"
            @send-message="onSendMessage"
          />
        </div>
      </div>
    </div>
  </woot-modal>
</template>


<style>
html.mayara-whatsapp-template-open .mayara-conversation-sidebar {
  display: none !important;
}
</style>

<style scoped>
.mayara-template-shell {
  width: min(86vw, 88rem);
  max-width: 100%;
  padding: 1.25rem 1.5rem 1.5rem;
}

.mayara-template-heading {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgb(var(--slate-5));
}

.mayara-template-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 0.875rem;
  background: #16a34a;
  color: white;
}

.mayara-template-icon i {
  font-size: 1.35rem;
}

.mayara-template-title {
  margin: 0;
  color: rgb(var(--slate-12));
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5rem;
}

.mayara-template-subtitle {
  margin: 0.2rem 0 0;
  color: rgb(var(--slate-10));
  font-size: 0.8125rem;
  line-height: 1.2rem;
}

.mayara-template-content {
  padding-top: 1rem;
}

.mayara-template-content-reply {
  max-width: 58rem;
  margin: 0 auto;
}

.mayara-reply-stage {
  max-height: 70vh;
  overflow-y: auto;
  padding: 0.25rem;
}

@media (max-width: 900px) {
  .mayara-template-shell {
    width: min(94vw, 92rem);
    padding: 1rem;
  }
}
</style>

<style>
.mayara-whatsapp-template-modal .modal-container {
  width: min(88vw, 90rem) !important;
  max-width: min(88vw, 90rem) !important;
}

@media (max-width: 900px) {
  .mayara-whatsapp-template-modal .modal-container {
    width: 96vw !important;
    max-width: 96vw !important;
  }
}
</style>
